import { render, staticRenderFns } from "./coins.vue?vue&type=template&id=1b6dcd04&scoped=true"
import script from "./coins.vue?vue&type=script&lang=js"
export * from "./coins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6dcd04",
  null
  
)

export default component.exports